




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Offer, ShipmentStatus } from '@/data/models/offer.model';
import store, { State } from '@/store';

@Component({})
export default class FattorinoOfferList extends Vue {
	@Prop() offer!: Offer;

	state!: State;

	ShipmentStatus = ShipmentStatus;

	constructor() {
		super();
		this.state = store;
	}

}
